import { useCallback, useRef } from 'react';
import { ScrollView } from 'react-native';
import { scrollViewElementTestID } from 'src/helpers/testIDs.helper';

export function useVerticalScrollView() {
  const scrollVierRef = useRef<ScrollView>(null);

  // IMPORTANT: this method must be called to value data-testid of the scroll view elements
  const getScrollViewElementTestId = useCallback((index: number) => scrollViewElementTestID(`${index}`), []);

  // IMPORTANT: to make it works, the elements of scroll view must have data-testid with value of getScrollViewElementTestId(index)
  const scrollToIndex = useCallback(
    (selectedIndex: number | undefined) => {
      if (scrollVierRef.current && selectedIndex !== -1 && selectedIndex !== undefined) {
        const testId = getScrollViewElementTestId(selectedIndex);
        const y = scrollVierRef.current.getInnerViewNode()?.querySelector(`[data-testid="${testId}"]`)?.offsetTop as
          | number
          | undefined;
        if (typeof y === 'number') {
          scrollVierRef?.current?.scrollTo({
            y,
            animated: true,
          });
        }
      }
    },
    [scrollVierRef.current],
  );

  return {
    scrollVierRef,
    scrollToIndex,
    getScrollViewElementTestId,
  };
}
